import React from 'react';

export default function KeyTable({ data, note }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="my-8 w-full max-w-full overflow-hidden">
      <div className="overflow-x-auto w-full rounded-[6px] border border-[#DCE3EC] bg-[#E8EEF8]">
        <div className="h-[2px] bg-[#2A4DB0] w-full" />
        <table className="w-full text-left text-[14px] sm:text-[15px] border-collapse min-w-[500px]">
          <thead>
            <tr className="border-b border-[#DCE3EC] text-[#141B22] font-semibold">
              <th className="py-2.5 sm:py-3 px-3 sm:px-4">Fødevare / tilstand</th>
              <th className="py-2.5 sm:py-3 px-3 sm:px-4">Holdbarhed på frost</th>
              <th className="py-2.5 sm:py-3 px-3 sm:px-4">Pakning</th>
              <th className="py-2.5 sm:py-3 px-3 sm:px-4">Optøning</th>
              <th className="py-2.5 sm:py-3 px-3 sm:px-4">Brug efter optøning</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#DCE3EC] text-[#141B22]">
            {data.map((row, idx) => (
              <tr key={idx} className="hover:bg-white/40 transition-colors">
                <td className="py-2.5 sm:py-3 px-3 sm:px-4 font-medium">{row.food}</td>
                <td className="py-2.5 sm:py-3 px-3 sm:px-4 text-[#2A4DB0] font-semibold whitespace-nowrap">{row.duration}</td>
                <td className="py-2.5 sm:py-3 px-3 sm:px-4 text-[#5C6670]">{row.pack}</td>
                <td className="py-2.5 sm:py-3 px-3 sm:px-4 text-[#5C6670]">{row.thaw}</td>
                <td className="py-2.5 sm:py-3 px-3 sm:px-4 text-[#5C6670]">{row.use}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {note && (
        <p className="mt-2 text-xs text-[#5C6670] italic">
          {note}
        </p>
      )}
    </div>
  );
}
